// src/components/Auth/Signup.js
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell, { AuthAlert } from "../../components/AuthShell";
import { auth, firestore } from "../../../firebase";

export default function Signup() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      setError("Passwords do not match.");
      return;
    }

    setIsSubmitting(true);

    try {
      setError("");
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        emailRef.current.value,
        passwordRef.current.value
      );
      const user = userCredential.user;
      await setDoc(doc(firestore, "accounts", user.uid), {
        admins: [user.email],
        teamMembers: [],
      });
      navigate("/dashboard");
    } catch (error) {
      setError(`Failed to create an account: ${error.message}`);
      console.error("SIGNUP_FAILED", error);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <AuthShell
      eyebrow="Start building"
      title="Create account"
      subtitle="Set up your workspace and publish your first video page when it is ready."
      footer={
        <p>
          Already have an account?{" "}
          <Link to="/login" className="font-semibold text-[#FF3A20] hover:text-[#e8321c]">
            Log in
          </Link>
        </p>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        {error && <AuthAlert>{error}</AuthAlert>}

        <div className="field-group">
          <label htmlFor="email" className="field-label">
            Email
          </label>
          <input
            type="email"
            id="email"
            ref={emailRef}
            required
            autoComplete="email"
            className="field-input"
            placeholder="you@example.com"
          />
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          <div className="field-group">
            <label htmlFor="password" className="field-label">
              Password
            </label>
            <input
              type="password"
              id="password"
              ref={passwordRef}
              required
              autoComplete="new-password"
              className="field-input"
              placeholder="Create password"
            />
          </div>

          <div className="field-group">
            <label htmlFor="passwordConfirm" className="field-label">
              Confirm
            </label>
            <input
              type="password"
              id="passwordConfirm"
              ref={passwordConfirmRef}
              required
              autoComplete="new-password"
              className="field-input"
              placeholder="Repeat password"
            />
          </div>
        </div>

        <button type="submit" className="primary-button w-full" disabled={isSubmitting}>
          {isSubmitting ? "Creating account..." : "Create account"}
        </button>
      </form>
    </AuthShell>
  );
}
